// Packages
import { Component } from "react";

// Assets
// import upArrow from "../../assets/images/up-arrow.png";
import updownload from "../../assets/images/whiteUpArrow.png";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";

class selectedVideos extends Component {
  constructor() {
    super();
    this.state = {
      selecteddata: [],
      file: null,
    };
    this.handleselectedFileChange = this.handleselectedFileChange.bind(this);
  }
  handleselectedFileChange(event) {
    this.setState({
      file: URL.createObjectURL(event.target.files[0]),
    });
  }
  render() {
    const selecteddata = [
      { name: "Front Angle_File Name clip 1.mp4", id: "1" },
      { name: "Front" },
      { name: "Front Angle_File Name clip 1.mp4", id: "2" },
      { name: "Front Angle_File Name clip 1.mp4", id: "3" },
      { name: "Front Angle_File Name clip 1.mp4", id: "4" },
      { name: "Front Angle_File Name clip 1.mp4", id: "5" },
    ];

    return (
      <div>
        <SchoolAdminDashboard />

        <div className="margin-auto mt-15">
          <section className="contact-section">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="grid">
                  <div className="row mt-40">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                      <label className="ml-2 fs-18 semi-bold">
                        Your Selected Files
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8 col-md-8 col-lg-8">
                    <div className="uploadDocuments-card p-20">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                          <div className="ml-2 bold fs-18 ">
                            <label className="bold fs-22">
                              365 files selected
                            </label>
                            <br></br>
                            {/* <input type="file" className="link-blue medium fs-16">+ Add More</input> */}
                            <label
                              htmlFor="upload-photo"
                              className="semi-bold link-blue cp"
                            >
                              + Add More Videos
                            </label>
                            <input type="file" name="photo" id="upload-photo" />
                          </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
                          <button className="semi-bold uploadFilesBtn">
                            <img src={updownload} className="mr-2" alt="" />
                            Start Uploading
                          </button>
                        </div>
                      </div>
                      <div>
                        {/* <input type="file" onChange={this.handleChange} multiple></input> */}
                      </div>
                      <div className="row bg-20">
                        {selecteddata.map((d) => (
                          <div
                            key={d.id}
                            className="col-6 col-sm-6 col-md-6 col-lg-6 brderbtm"
                          >
                            <div className="row pt-20 pb-20 ">
                              <div className="col-8 semi-bold fs-16 ">
                                <label className="txt-overflow">{d.name}</label>
                              </div>
                              <div className="col-4 fs-16 txtred medium">
                                Remove
                              </div>
                            </div>
                            {/* <div className="brderbtm"></div> */}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
export default selectedVideos;
